import React from 'react';
import { Paper, makeStyles, Button } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { uomPieces } from '../../Config/constants';

export default function OrderDetailMaterials(props) {

    const classes = useStyles();

    const { t } = useTranslation();
    const [value, setValue] = React.useState(0);

    const BOMRows = props.productionOrder.bomIn.map(m => {

        let description = m.productName
        if (JSON.parse(m.bomMetaData).find(x => x.MetaDataType === 1).MetaData[0].Color) {
            description += " - " + JSON.parse(m.bomMetaData).find(x => x.MetaDataType === 1).MetaData[0].Color
        }
        if (JSON.parse(m.bomMetaData).find(x => x.MetaDataType === 1).MetaData[0].Length) {
            description += " - " + JSON.parse(m.bomMetaData).find(x => x.MetaDataType === 1).MetaData[0].Length
        }

        let uom = m.uom.toLowerCase()
        if (uom === uomPieces && m.quantityToConsume === 1) {
            uom = "piece"
        }

        return (
            createBOMData(m.productReference, description, m.quantityToConsume, uom, m.productId))
    }
    )

    function createBOMData(code, name, quantity, uom, productId) {
        return { code, name, quantity, uom, productId };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return <div className={classes.orderDetailMaterials}>

        <AppBar position="static" className={classes.appBar}>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label="BOM" {...a11yProps(0)} className={clsx({ [classes.activeTab]: value === 0, [classes.notActiveTab]: value !== 0 })} />
            </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} className={classes.BOMPanel}>
            {/* <div className={classes.head}>
                <div className={classes.addManually}>
                    <Button className={classes.button} onClick={() => props.openMaterialCorrectionDrawer(true)}>
                        <div className={classes.addManuallyText}>
                            {'- ' + t('Correct Material')}
                        </div>
                    </Button>
                    <Button className={classes.button} onClick={() => props.openManualReplenishmentDrawer(true)}>
                        <div className={classes.addManuallyText}>
                            {'+ ' + t('Add Material')}
                        </div>
                    </Button>
                </div>
            </div> */}
            <TableContainer component={Paper} className={classes.paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.headCell}>{'Production details'}</TableCell>
                            <TableCell className={classes.headCell}>{'Description'}</TableCell>
                            <TableCell className={classes.quantityAtMachineHeadCell} align="right">{'Quantity needed'}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {BOMRows.map((row) => (
                            <TableRow key={row.name} className={classes.row}>
                                <TableCell className={classes.infoCell}>{row.code}</TableCell>
                                <TableCell className={classes.infoCell}>{row.name}</TableCell>
                                <TableCell className={classes.quantityAtMachineCell} align="right">{row.quantity + " " + row.uom.toLowerCase()}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </TabPanel>
    </div>
}

const useStyles = makeStyles({
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        width: "20%"
    },
    quantityAtMachineCell: {
        padding: "3px",
        paddingRight: "60px",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    quantityAtMachineHeadCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        padding: "3px",
        paddingTop: "0px",
        paddingRight: "60px",
        border: "none",
    },
    paper: {
        boxShadow: 'none'
    },
    title: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        float: "left"
    },
    addManually: {
        float: "right"
    },
    addManuallyText: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: FlagstoneTheme.palette.primary.main,
        textTransform: "none",
        marginRight: "5px"
    },
    orderDetailMaterials: {
        padding: "20px",
        height: "auto"
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        padding: "3px",
        paddingTop: "0px",
        border: "none",
    },
    arrowForward: {
        color: FlagstoneTheme.palette.primary.main,
        width: "15px",
        height: "15px",
        float: "left"
    },
    button: {
        padding: "0px"
    },
    appBar: {
        backgroundColor: "rgba(1,1,1,0)",
        boxShadow: "none",
        color: "#020100",
        "& > div > div > span": {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            height: "3px",
            width: "80px !important"

        },
        borderBottom: "1px solid #e3e0de",
        marginLeft: "30px",
        width: "96%",
        overflow: "visible"

    },
    activeTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: 'bold',
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    notActiveTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    BOMPanel: {
        "& > div": {
            paddingTop: "10px !important"
        },
    }
});